module.exports = __webpack_public_path__ + "static/media/file-invoice-dollar.e3980f67.svg";